
import Vue from 'vue';
import { VInput } from 'vuetify/lib';
import {AnuncioExterno} from "@/models/AnuncioExterno";
import AnuncioService from '@/services/AnuncioExternoService';
import MaterialService from '@/services/MaterialService';
import TipoAnuncioService from '@/services/TipoAnuncioService';
import RULES from '@/mixins/rules';
import EstablecimientoService from '@/services/EstablecimientoService';
import CustomFile from "@/components/Common/CustomFile.vue";
import CustomFileInputAnuncio from "@/components/Common/CustomFileAnuncio.vue";
import CatastroService from "@/services/CatastroService";
import {VForm} from "@/types/formvalidate";
import Direccion from "@/components/Beneficiarios/Direccion.vue";
import {Domicilio} from "@/models/Domicilio";
import AnuncioExternoService from "@/services/AnuncioExternoService";
import EventBus from "@/plugins/event-bus";
import PredialEstadoCuenta from '@/components/Common/EstadoCuenta.vue';
import { AnuncioDetalle } from '@/models/AnuncioDetalle';

export default Vue.extend(
  {
    props: {
      value2: Object,
      idEstablecimiento: {
        type: Number,
        default: 0,
      },
      idSolicitudExterno: {
        type: Number,
        default: 0,
      },
      clave_catastralSave:{
        type: String,
        default: null,
      },
      isNotSubmit: {
        type: Boolean,
        default:true
      },
      object: {
        type: AnuncioExterno,
        default: new AnuncioExterno()
      },
      estatus: {
        type: Number,
        default: 1
      },
      update: {
        type: Boolean,
        default: false
      },
    },
    mixins: [RULES],
    data: () => ({
      riesgo: false,
      arrayAnuncios: [] as any[],
      uploadPercentage: 0,
      defaultLatitud: 18.520326,
      defaultLongitud: -88.305718,
      menu: false,
      dialog: false,
      menu_fin: false,
      loading: false,
      editable: false,
      formData: new AnuncioExterno(),
      formDefault: new AnuncioExterno(),
      disabledExterno: true,
      fileInputRenovacion: null,
      fileInputArrendamiento: null,
      fileInputPropiedad: null,
      fileInputCedulaCatastral: null,
      disabledForm: {
        localidad: true,
        asentamiento: true,
      },
      tipoPropiedades: [] as any[],
      dialogPredial: false,
      disabledPredial: false,
      dialogView: false,
      isMesDisabledArray: [],
      materiales: [] as any[],
      tiposAnuncios: [] as any[],
      periodos: Array.from({ length: 3 }, (_, i) => (new Date().getFullYear() - i).toString()),
      documento: null,
      showFotografia: false,
      showMemoria: false,
      showResponsiva: false,
      dialogSendReview: false,
      selectedSolicitud: new AnuncioExterno() as any,
      dialogPDF: false,
      usePiezaDia: [],
      usePiezaMes: [],
      usePieza: [],
      fileInputValue: null,
      selectedOption: null,
      anunciosAll: [new AnuncioExterno()],
      dialogEstadoCuenta: false,
    }),
    watch: {
      object:{
        immediate: true,
        deep: true,
        handler(d){
          this.formData = this.object;
          this.selectedSolicitud = this.object;

          if(this.estatus == 10 || this.estatus == 5) {
            this.disabledExterno = true;
          }
          if (this.formData.is_mecanismo_electrico === 1) {
            //@ts-ignore
            this.selectedOption = true;
          } else if (this.formData.is_accion_viento === 1) {
            //@ts-ignore
            this.selectedOption = false;
          }
        }
      },
      /*'formData.tipo_anuncio_id': {
        immediate: true,
        handler(value) {
          const piezaDiaAnuncios = [7];
          const piezaMesAnuncios = [1, 8, 10];
          const piezaAnuncio = [4, 5]
          
          this.usePiezaDia = piezaDiaAnuncios.includes(value);
          this.usePiezaMes = piezaMesAnuncios.includes(value) && !piezaDiaAnuncios.includes(value);
          this.usePieza = piezaAnuncio.includes(value);
        }
      },*/
      'selectedOption': {
        handler(value) {
          if (value === true) {
            this.formData.is_mecanismo_electrico = true;
            this.formData.is_accion_viento = false;
          } else if (value === false) {
            this.formData.is_mecanismo_electrico = false;
            this.formData.is_accion_viento = true;
          }
        }
      },
      'formData.tipo_propiedad_id': function (newVal) {
        if (newVal === 1) {
          this.fileInputArrendamiento = null;
        } else if (newVal === 2) {
          this.fileInputPropiedad = null;
        }
      },
      anunciosAll: {
        handler(anuncios) {
          /*anuncios.forEach((anuncio: any, index: number) => {
            const piezaDiaAnuncios = [7];
            const piezaMesAnuncios = [1];
            const piezaAnuncio = [4, 5, 8, 10];

            this.$set(this.usePiezaDia, index, piezaDiaAnuncios.includes(anuncio.tipo_anuncio_id));
            this.$set(this.usePiezaMes, index, piezaMesAnuncios.includes(anuncio.tipo_anuncio_id) && !piezaDiaAnuncios.includes(anuncio.tipo_anuncio_id));
            this.$set(this.usePieza, index, piezaAnuncio.includes(anuncio.tipo_anuncio_id));

            if(anuncio.tipo_anuncio_id === 1){
              this.updateMesField(anuncio, index);
            }
          });*/
        },
        deep: true, // Para observar cambios profundos en el arreglo
        immediate: true
      },
    },
    methods: {
      validacionRiesgo(){
        this.riesgo = false;
        //Recorrer el arreglo de anuncios para ver si hay algún tipo 10 o 2
        this.arrayAnuncios.forEach((anuncio: any) => {
          //console.log(anuncio);
          if(anuncio.tipo_anuncio_id == 10 || anuncio.tipo_anuncio_id == 2){
            this.riesgo = true;
          }
        })
      },
      validacionPiezaMes(value: any){ 
        let response = false;
        const piezaDiaAnuncios = [7];
        const piezaMesAnuncios = [1];
        
        response = piezaMesAnuncios.includes(value) && !piezaDiaAnuncios.includes(value);

        //Validación renovación cuando sea tipo anuncio mantas y lonas y mes actual sea noviembre
        // cargar 12 meses por default
        let anuncio = this.anunciosAll[0];
        if(value === 1){
          const currentMonth = new Date().getMonth() + 1;
          const isRenovacionChecked = this.formData.renovacion;
          if (isRenovacionChecked && currentMonth === 11) {
            this.$set(anuncio, 'mes', 12);
            this.$set(this.isMesDisabledArray, 0, true);
          } else {
            this.formData.mes = 0;
            this.isMesDisabled = this.disabled;
          }
          //this.updateMesField();
        }
        return response;
      },
      validacionPiezaDia(value: any){ 
        let response = false;
        const piezaDiaAnuncios = [7];
        
        response = piezaDiaAnuncios.includes(value);

        return response;
      },
      validacionPieza(value: any){
        let response = false;
        const piezaAnuncio = [4, 5, 8, 10]
        response = piezaAnuncio.includes(value);
        return response;
      },
      deleteAnuncio(index: number, item: any) {
        //console.log(index, item);
        this.arrayAnuncios.splice(index, 1);
        if (item.id) {
          AnuncioService.deleteDetalle(item.id).then(() => {
            //console.log('Anuncio eliminado');
            this.$toast.success('Anuncio eliminado');
          })
        }
      },
      addAnuncioDetalle() {
        this.arrayAnuncios.push(new AnuncioDetalle());
      },
      async consultarCatastro(){
        /*let {data: {resultados: catastro}} = await CatastroService.searchByClaveCatastral(this.formData.clave_catastral);

        if(catastro != false){
          this.formData.domicilio.codigo_postal = catastro.cp.toString();
          this.formData.domicilio.localidad_id = catastro.id_localidad;
          this.formData.domicilio.colonia_id = catastro.id_colonia;
          this.formData.domicilio.calle_id = catastro.id_calle;
          this.formData.domicilio.numero_exterior = catastro.num_predio;*/

          let { data } = await EstablecimientoService.getPagoPredial(this.formData.clave_catastral);

          if (data.data) {
            this.disabledExterno = false;
            //this.disabledPredial = true;
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message)
            this.dialogPredial = true;
          }
        /*}else{
          this.$toast.error("La clave no ha sido encontrada en catastro")
        }*/
      },
      addAnuncio() {
        this.anunciosAll.push(new AnuncioExterno());
      },
      pagarPredialLinea(){
        window.open('https://predial.opb.gob.mx/predial', '_blank')
        //window.open(`https://predial.opb.gob.mx/predial?clave_catastral=${this.formData.clave_catastral}`, '_blank')
      },
      async generarPagoPredial(){
        //this.dialogEstadoCuenta = true;
        await EstablecimientoService.newRequest(`licencia/${this.formData.clave_catastral}/generatePagoPredial`,{},'POST','Temp')
            .then((response) => {
              let file = new Blob([response.data],{type: response.headers['content-type']});
              const url = window.URL.createObjectURL(file);
              const tipoArchivo = 'Estado de cuenta.'
              //@ts-ignore
              this.documento = {
                title: tipoArchivo,
                url: url,
                mime: response.headers['content-type']
              }
              this.dialogView = true;
            }) 
      },
      cancelarEnvio() {
        this.selectedSolicitud = null;
        this.dialogSendReview = false;
      },
      async showFile(id: any){
        //@ts-ignore
        const response = await EstablecimientoService.descargarFormato(`documentacion/${id}`,{},'GET','Temp');

        let file = new Blob([response.data],{type: response.headers['content-type']});
        const url = window.URL.createObjectURL(file);                

        //@ts-ignore
        this.documento = {
            //@ts-ignore
            title: this.label,
            url: url,
            mime: response.headers['content-type'] 
        }
        this.dialog = true;
      },
      handleFileChange(index: number, event: any, type: string) {
        let file;
        if (event.target && event.target.files) {
          file = event.target.files[0];
        } else {
          file = event;
        }
        this.setFotografia(index, file, type);
      },
      setFotografia(index: number, file: any, type: string) {
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

        if (file) {
          if (!validTypes.includes(file.type)) {
            this.$toast.error('Para la fotografía solo se permiten archivos PNG, JPEG, JPG');
            return;
          }
          const fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
            const result = fileReader.result;
            let obj = {
              ...this.anunciosAll[index]
            }
            obj[type] = result;
            this.$set(this.anunciosAll, index, obj);
          });

          fileReader.readAsDataURL(file);
        } else {
          console.log('No se seleccionó ningún archivo');
        }
        file = null;
      },
      setCedula(e: any){
        const file = e.target ? e.target.files[0] : e;
        if (file && file.type !== 'application/pdf') {
          this.$toast.error('Para la cedula catastral solo se permiten archivos PDF');
        } else {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            const file = fileReader.result;
            this.formData.constancia_cedula_catastral = file + "";
          });
          fileReader.readAsDataURL(e);
        }
      },
      setArrendamiento(e: any){
        const file = e.target ? e.target.files[0] : e;
        if (file && file.type !== 'application/pdf') {
          this.$toast.error('Para el contrato de arrendamiento solo se permiten archivos PDF');
        } else {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            const file = fileReader.result;
            this.formData.documento_arrendamiento = file + "";
          });
          fileReader.readAsDataURL(e);
        }
      },
      setPropiedad(e: any){
        const file = e.target ? e.target.files[0] : e;
        if (file && file.type !== 'application/pdf') {
          this.$toast.error('Para el documento de propiedad solo se permiten archivos PDF');
        } else {
          const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            const file = fileReader.result;
            this.formData.documento_propiedad = file + "";
          });
          fileReader.readAsDataURL(e);
        }
      },
      validateFileRenovacion(index: number, event: any) {
        let file;
        if (event.target && event.target.files) {
          file = event.target.files[0];
        } else {
          file = event;
        }
        this.setAnteriorPermiso(index, file);
      },
      setAnteriorPermiso(index: number, file: any) {
        if (file) {
          if (file && file.type !== 'application/pdf') {
            this.$toast.error('Para el anterior permiso solo se permiten archivos PDF');
          } else {
            const fileReader = new FileReader();
            fileReader.addEventListener('load', () => {
              const result = fileReader.result;
              this.$set(this.anunciosAll, index, {
                ...this.anunciosAll[index],
                anterior_permiso_anuncio: result
              });
            });
            fileReader.readAsDataURL(file);
          }
        } else {
          console.log('No se seleccionó ningún archivo');
        }
        /*const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          var file = fileReader.result;
          this.formData.anterior_permiso_anuncio = file + "";
        });
        fileReader.readAsDataURL(file);*/
      },
      clearFotografia() {
        //@ts-ignore
        //this.$refs.inputFoto.reset();
        this.formData.fotografia = null; // Esto debería borrar el archivo seleccionado
      },
      setMemoriaEstructural(index:number, e: any){
        const file = e.target ? e.target.files[0] : e;
        if (file && file.type !== 'application/pdf') {
          this.$toast.error('Para memoria de calculo estructural solo se permiten archivos PDF');
        } else {
          const fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
            const result = fileReader.result;
            this.$set(this.anunciosAll, index, {
              ...this.anunciosAll[index],
              memoria_calculo_estructural: result
            });
          });
          this.anunciosAll[index].espectacular = 1;
          fileReader.readAsDataURL(file);
          /*const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            var file = fileReader.result;
            this.formData.espectacular = 1;
            this.formData.memoria_calculo_estructural = file + "";
          });
          fileReader.readAsDataURL(e);*/
        }
      },
      setResponsivaTerceros(index: number, e: any){
        const file = e.target ? e.target.files[0] : e;
        if (file && file.type !== 'application/pdf') {
          this.$toast.error('Para la carta responsiva de daño a terceros solo se permiten archivos PDF');
        } else {
          const fileReader = new FileReader();
          fileReader.addEventListener('load', () => {
            const result = fileReader.result;
            this.$set(this.anunciosAll, index, {
              ...this.anunciosAll[index],
              responsiva_terceros: result
            });
          });
          this.anunciosAll[index].espectacular = 1;
          fileReader.readAsDataURL(file);
          /*const fileReader = new FileReader()
          fileReader.addEventListener('load', () => {
            var file = fileReader.result;
            this.formData.espectacular = 1;
            this.formData.responsiva_terceros = file + "";
          });
          fileReader.readAsDataURL(e);*/
        }
      },
      reset() {
        this.formData = Object.assign({}, this.formDefault);
      },
      async handleFormSubmit() {
        //this.formData.locacion_id = this.idEstablecimiento;
        if(this.idSolicitudExterno > 0) {
          this.formData.clave_catastral = this.clave_catastralSave;
        }
        EventBus.$emit("update-direccion");
        this.formData.anuncios = this.anunciosAll;
        this.formData.arreglo_anuncios = this.arrayAnuncios;
        //console.log('datanews->',this.formData);
        await AnuncioExternoService.create(this.formData)
        .then((response) => {
            if (response.data.success) {
              //@ts-ignore
              this.fileInputValue = null;
              this.$toast.success('Solicitud de anuncio en vía pública registrado exitosamente');
              //this.$emit('formSubmitted', response.data);
              this.reset();
              this.$router.push('/admin/anuncios-externos');
            } else {
              this.$toast.error(response.data.message);
            }
            
          })
          .catch((error) => {
            this.disabledExterno = false;
            ////this.$toast.error(error.response.data.message);
          });
      },
      async handleAnuncioFormSubmit() {
        if(this.idSolicitudExterno > 0) {
          this.formData.clave_catastral = this.clave_catastralSave;
        }
        //console.log('datanewanuncio->',this.formData);
        await AnuncioExternoService.createAnuncio(this.formData)
            .then((response) => {
              if (response.data.success) {
                //@ts-ignore
                this.fileInputValue = null;
                this.reset();
                this.$emit('formSubmitted', response.data);
                this.$toast.success('Anuncio registrado exitosamente');
              } else {
                this.$toast.error(response.data.message);
              }

            })
            .catch((error) => {
              this.disabledExterno = false;
              ////this.$toast.error(error.response.data.message);
            });
      },
      async handleFormUpdateSubmit() {
        //this.disabled = false;
        Object.keys(this.formData).forEach((key) => {
          const value = this.formData[key];
        });

        let response = await AnuncioExternoService.update(this.formData.id,this.formData).then((response) => {
          if (response.data.success) {
            this.fileInputValue = null;
            this.$toast.success('Anuncio Actualizado exitosamente');
            this.$emit('formSubmitted', response.data);
          }else{
            this.$toast.error(response.data.message);
          }
          this.fileInputRenovacion = null;
          this.fileInputArrendamiento = null;
          this.fileInputPropiedad = null;
          this.fileInputCedulaCatastral = null;
        }).catch((error) => {
          this.disabledExterno = false;
        });
      },
      async getData() {
        await MaterialService.getAll().then((response) => {
          this.materiales = response.data;
        });

        await TipoAnuncioService.getAll()
          .then((response) => {
            this.tiposAnuncios = response.data;
          });

        await EstablecimientoService.getTipoPropiedadesAnuncios().then((response) => {
          this.tipoPropiedades = response.data;
        });
      },
      deleteModal(){
        //this.$emit('delete', this.$attrs.index);
        if (this.object.id != null) {
          AnuncioService.delete(this.object.id).then((response) => {
            if (response.data.success) {
              this.$emit('delete', this.$attrs.index);
              this.$toast.success('Anuncio eliminado exitosamente');
            }else{
              this.$toast.error(response.data.message);
            }
            
          }).catch((error) => {
            this.disabledExterno = false;
          });
        }else{
          this.$emit('delete', this.$attrs.index);
        }
        
      },
      changeFile(type: any) {
        switch (type) {
          case 'fotografia':
            this.showFotografia = true;
            break;
          case 'memoria':
            this.showMemoria = true;
            break;
          case 'responsiva':
            this.showResponsiva = true;
            break;
        }
      },
      setDomicilio(domicilio: Domicilio) {
        this.formData.domicilio = Object.assign({}, domicilio);
      },
      closeEstadoCuenta() {
        this.dialogEstadoCuenta = false;
      },
      updateMesField(anuncio: any, index: number) {
        const currentMonth = new Date().getMonth() + 1;
        const isTipoAnuncioValid = anuncio.tipo_anuncio_id === 1;
        const isRenovacionChecked = anuncio.renovacion;

        if (isTipoAnuncioValid && isRenovacionChecked && currentMonth === 11) {
          this.$set(anuncio, 'mes', 12);
          this.$set(this.isMesDisabledArray, index, true);
        } else {
          this.$set(anuncio, 'mes', anuncio.mes);
          this.$set(this.isMesDisabledArray, index, this.disabledExterno);
        }
      }
    },
    components: {Direccion, CustomFileInputAnuncio, CustomFile, VInput, PredialEstadoCuenta },
    computed: {
      esDiciembre(): boolean {
        const mesActual = new Date().getMonth() +1 ;
        return mesActual === 12;
      },
      form(): VForm {
        return this.$refs.form as VForm;
      },
      formDir(): VForm {
        return this.$refs.formDireccion as VForm;
      },

     },
    mounted() {
      if (this.formData.id || this.idSolicitudExterno > 0) {
        this.disabledExterno = false;
      }

      this.getData();
      //this.arrayAnuncios.push(new AnuncioDetalle());
      if (this.object.anuncio_detalle.length == 0) {
        this.arrayAnuncios.push(new AnuncioDetalle());
      } 
      this.validacionRiesgo();
    }
  }
);
